import { createFileRoute } from "@tanstack/react-router";
import { Bookings } from "@/bookings/Bookings";
import { ErrorComponent } from "@/components/Error";

export const Route = createFileRoute("/(authed)/_layout/bookings/_tabbed/")({
  component: Bookings,
  errorComponent: (props) => (
    <ErrorComponent title="Error" message="There was a problem loading your bookings." {...props} />
  ),
});
